import React from 'react';
import { AvTag, AvTooltip } from '@fabric-ui/components';
import { ellipsis, flex } from '@fabric-ui/theme';
import { Box, Button, capitalize } from '@mui/material';
import { APP_PATHS, AppPathKey } from '../types';
import { appsOptions } from './newNavigation/appbar.constants';

interface Props {
  apps: AppPathKey[];
}
export const AppIcon = ({ app }) => {
  const { iconFull, name } = appsOptions.find(({ enumValue }) => enumValue === app)!;
  return (
    <AvTooltip
      title={capitalize(name)}
      key={name}
      muiProps={{ placement: 'top' }}
      popperProps={{ modifiers: [{ name: 'offset', options: { offset: [2, -8] } }] }}>
      <Button>
        <Box sx={{ borderRadius: '8px', ...flex.center, img: { flexShrink: 0 } }}>{iconFull}</Box>
      </Button>
    </AvTooltip>
  );
};

const AvAppTag: React.FC<Props> = ({ apps }) => (
  <Box sx={{ ...flex.itemsCenter, gap: 1, whiteSpace: 'nowrap' }}>
    {apps.map(app => {
      const { iconFull, name } = appsOptions.find(({ id }) => id === APP_PATHS[app])!;
      return (
        <AvTag
          sx={{ pl: 0, py: 0 }}
          key={app}
          text={
            <Box sx={{ ...flex.itemsCenter, gap: '6px', ...ellipsis, borderBottomLeftRadius: 7, borderTopLeftRadius: 7 }}>
              {iconFull}
              <span>{name}</span>
            </Box>
          }
        />
      );
    })}
  </Box>
);

export default AvAppTag;
